import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnHiddenComponent} from './hidden.component';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [GnHiddenComponent],
  exports: [GnHiddenComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  entryComponents: []
})
export class GnHiddenModule {
}
